/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const unregisterPushTokenBodySchema = z.object({
  token: z.string(),
});

export type IUnregisterPushTokenBody = z.infer<typeof unregisterPushTokenBodySchema>;
